/**
 * Configuração do worker do PDF.js — fonte ÚNICA, mas fora do ponto de entrada.
 *
 * **Por que existe.** O `react-pdf` precisa saber onde está o worker antes de
 * renderizar qualquer PDF. O worker é servido SAME-ORIGIN (bundlado pelo Vite),
 * não por CDN: a CSP de produção é `script-src 'self'` sem `worker-src`, então
 * um worker externo seria bloqueado. O bundle local satisfaz a CSP e funciona
 * offline.
 *
 * **Por que saiu do `main.tsx`.** Estava no entry justamente para ser fonte
 * única — intenção correta, custo alto: importar `react-pdf` ali colocava a
 * biblioteca inteira no grafo ansioso, e **todo usuário baixava ~98 KB
 * (comprimidos) de renderizador de PDF só para abrir a tela de login**,
 * inclusive o parceiro no celular, que na maioria das sessões nunca abre um PDF.
 *
 * Este módulo preserva a propriedade que importava (um só lugar configura o
 * `workerSrc`) sem o custo: quem renderiza PDF importa daqui, e o custo passa a
 * ser pago por quem usa.
 *
 * A configuração é idempotente — importar de vários lugares é seguro, o módulo
 * é avaliado uma vez pelo bundler.
 */
import { pdfjs } from "react-pdf";
import pdfWorkerUrl from "pdfjs-dist/build/pdf.worker.min.js?url";

pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;

export { pdfjs };
